import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLearningDevelopment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#7de5e3",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6 15H3.8C3.4287 15 3.0726 14.8525 2.81005 14.5899C2.5475 14.3274 2.4 13.9713 2.4 13.6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.26667 1C3.7716 1 3.2968 1.19667 2.94674 1.54673C2.59667 1.8968 2.4 2.3716 2.4 2.86667V13.6C2.4 13.2287 2.5475 12.8726 2.81005 12.6101C3.0726 12.3475 3.4287 12.2 3.8 12.2H13.1333C13.2571 12.2 13.3758 12.1508 13.4633 12.0633C13.5508 11.9758 13.6 11.8571 13.6 11.7333V1.46667C13.6 1.3429 13.5508 1.2242 13.4633 1.13668C13.3758 1.04917 13.2571 1 13.1333 1H4.26667Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6667 15V12.2",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.554 12.4792V15.1782H3.96623L2.34673 14.0986V2.90993L3.57359 1.29041H13.5355V11.2523L12.554 12.4792Z",
			fill: "currentColor",
			fillOpacity: .25
		})
	]
});
export default SvgLearningDevelopment;
